<template>
	<b-form-file
		:state="state"
		:value="value"
		@input="$emit('input', $event)"
		placeholder="Valitse tiedosto..."
		browse-text="Selaa"
	>
	</b-form-file>
</template>

<script>
export default {
	props: ["value", "state"]
};
</script>

<style lang="scss" scoped></style>
